import React, { useEffect } from "react";
import { MdWifiOff, MdRefresh, MdStorage } from "react-icons/md";
import styles from "./NoNetworkView.module.scss";
import { EmptyState } from "../../../common/components/emptyState/EmptyState";
import { useScreenTracking } from "../../../common/hooks/useScreenTracking";

interface NoNetworkViewProps {
  onRetry?: () => void;
  hasCache?: boolean;
}

export const NoNetworkView: React.FC<NoNetworkViewProps> = ({
  onRetry,
  hasCache = false,
}) => {
  const { trackNoNetwork } = useScreenTracking();

  useEffect(() => {
    trackNoNetwork();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {hasCache && (
          <div className={styles.cacheIndicator}>
            <MdStorage size={14} color="var(--primary)" />
            <span className={styles.cacheText}>Кэш</span>
          </div>
        )}

        <EmptyState
          icon={MdWifiOff}
          title={hasCache ? "Нет соединения" : "Нет данных"}
          description={
            hasCache
              ? "Вы просматриваете кэшированные данные. Подключитесь к интернету для обновления каталога."
              : "Нет подключения к интернету и отсутствуют сохранённые данные. Подключитесь к сети для загрузки каталога."
          }
        />

        {onRetry && (
          <button className={styles.retryButton} onClick={onRetry}>
            <MdRefresh size={20} />
            <span>Повторить попытку</span>
          </button>
        )}

        {!hasCache && (
          <p className={styles.offlineMessage}>
            Работа офлайн доступна после первой загрузки каталога
          </p>
        )}
      </div>
    </div>
  );
};
